export const iconFontAwesomeHumanitarianDroplet = (
	<i className="fa-solid fa-droplet"></i>
);
